import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/lib/api';

/**
 * Cache policy for the whole app. Every query still declares its own
 * `staleTime` (ARCHITECTURE §7 forbids leaning on the default) — this floor
 * only keeps a forgotten one from refetching on every mount.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // One retry, and only for the failures a retry can actually fix:
        // repeating a 422 or a 403 just repeats the answer.
        retry: (failureCount, error) => failureCount < 1 && (!isApiError(error) || error.retryable),
      },
      mutations: { retry: 0 },
    },
  });
}
